var render = function render(){var _vm=this,_c=_vm._self._c;return _c('headerbar',[_c('div',{attrs:{"id":"headbar"}},[_c('h1',{staticStyle:{"text-align":"center"}},[_vm._v(_vm._s(_vm.pageTitle))]),_c('hr')])])
}
var staticRenderFns = []

export { render, staticRenderFns }